import { Group, ManageAccountsOutlined } from "@mui/icons-material";

import { MenuList, Stack } from "@mui/material";
import { RolePermission, UserPermission } from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { NavigationItem } from "./navigation-item";

export const Navigation = () => {
  const accessManageAccount = useCheckPermission([UserPermission.Access]);
  const accessManageRole = useCheckPermission([RolePermission.Access]);
  return (
    <Stack
      component={"nav"}
      sx={{
        flexShrink: 0,
      }}
    >
      <MenuList dense sx={{ overflow: "auto" }}>
        {accessManageAccount.allowAccess && (
          <NavigationItem to="users" icon={<ManageAccountsOutlined />}>
            Tài khoản
          </NavigationItem>
        )}

        {accessManageRole.allowAccess && (
          <NavigationItem to="role-and-permission" icon={<Group />}>
            Vai trò và phân quyền
          </NavigationItem>
        )}

        {/* <NavigationItem to="catalogue" icon={<DeveloperBoardOutlined />}>
          Danh mục
        </NavigationItem> */}
      </MenuList>
    </Stack>
  );
};
